// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7e43e47","453":"ee43c784","732":"70ea4fd9","977":"57c9d5c4"}[chunkId] + ".chunk.js";
};